/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { TrademarkOutlined } from '@ant-design/icons';
import Padrones from 'views/Padrones/Padrones';
import * as Empresas from 'views/Padrones/Empresas';
import * as Comercios from 'views/Padrones/Comercios';
import * as Vehiculos from 'views/Padrones/Vehiculos';
// import PredioSinConfigPadron from 'views/Padrones/PredioSinConfigPadron';
// import Predio from 'views/Padrones/Predio';
import Ciudadano from 'views/Padrones/Ciudadano';
import PadronMultiple from 'components/PadronMultiple';
import ConfiguracionDePadrones from 'views/Padrones/ConfiguracionDePadrones';
import Bitacora from 'components/Catalogos/TableBitacora';
import AlmacenVehicular from 'views/Padrones/AlmacenVehicular';
import TipoFolioVehicular from 'views/Padrones/TipoFolioVehicular';
import EstadoFolioPlaca from 'views/Padrones/EstadoFolioPlacas';
import ContratoFolioPlaca from 'views/Padrones/ContratoFolioPlacas';
import DetalleContratoFolioPlaca from 'views/Padrones/DetalleContratoFoliosPlacas';
import BitacoraRecepcionFolioVehicular from 'views/Padrones/BitacoraRecepcionFoliosVehiculares';
import InventarioPlacaTarjetaCirculacion from 'views/Padrones/InventarioPlacasTarjetasCirculacion';
import CuotaFijaParaVehiculos from 'views/Padrones/CatalogosVehiculares/CuotaFijaParaVehiculos';
import PorcentajesVehiculares from 'views/Padrones/CatalogosVehiculares/PorcentajesVehiculares';
import TipoDeAplicacionDeTarifasVehiculares from 'views/Padrones/CatalogosVehiculares/TiposDeAplicacionDeTarifasVehiculares';
import TabuladorVehicular from 'views/Padrones/CatalogosVehiculares/TabuladorVehicular';
import CatalogoDeVersiones from 'views/Padrones/CatalogosVehiculares/CatalogoDeVersiones';
import * as Contribuyente from 'views/Padrones/Contribuyente';
import ArchivoDeDireccionVerificada from 'views/Padrones/ArchivosDeDireccionVerificada';
import Motocicletas from 'views/Padrones/Motocicletas';
import Remolques from 'views/Padrones/Remolques';
import AsignacionDePlacas from 'views/Padrones/GestionDePlacas/AsignacionDePlacas';
import ConfiguracionesDeAsignacionesDePlacas from 'views/Padrones/GestionDePlacas/ConfiguracionesDeAsignacionesDePlacas';
import Marcas from 'views/Padrones/CatalogosVehiculares/Marcas';
import Lineas from 'views/Padrones/CatalogosVehiculares/Lineas';
import PlacasVehiculares from 'views/Padrones/CatalogosVehiculares/Placas';
import ZonaExclusiva from 'views/Padrones/ZonasExlusivas/ZonasExclusivas';
import TipoZonaExclusiva from 'views/Padrones/ZonasExlusivas/TiposZonasExclusivas';
import Mercado from 'views/Padrones/Mercados/Mercado';
import ExpedienteDeMercado from 'views/Padrones/Mercados/ExpedienteDeMercado';
import GiroDeMercado from 'views/Padrones/Mercados/GiroDeMercado';
import GiroDeComercioInformal from 'views/Padrones/ComercioInformal/GiroDeComercioInformal';
import ExpedienteDeComercioInformal from 'views/Padrones/ComercioInformal/ExpedienteDeComercioInformal';
import ExpedienteDeLicencia from 'views/Padrones/LicenciaDeFuncionamiento/ExpedienteDeLicencia';
import GiroDeLicencia from 'views/Padrones/LicenciaDeFuncionamiento/GiroDeLicencia';
import CategoriasDeGiro from 'views/Padrones/LicenciaDeFuncionamiento/CategoriasDeGiro';
import TiposDeAlcoholes from 'views/Padrones/TiposDeAlcoholes';
import ContratosDePolicias from 'views/Padrones/Policias/ContratosDePolicias';
import TipoDeContratosDePolicias from 'views/Padrones/Policias/TiposDeContratosDePolicias';
import TipoDeServicioDePolicias from 'views/Padrones/Policias/TipoDeServiciosDePolicias';
// import ClasesDeAnuncios from 'views/Padrones/Anuncios/ClaseDeAnuncios';
import TiposDeAnuncios from 'views/Padrones/Anuncios/TiposDeAnuncios';
// import Peritos from 'views/Padrones/Anuncios/Peritos';
// import Aseguradoras from 'views/Padrones/Anuncios/Aseguradoras';
import ExpedienteDeAnuncio from 'views/Padrones/Anuncios/ExpedientesDeAnuncios';
import TiposDeMercados from 'views/Padrones/Mercados/TiposDeMercados';
import ClaseDeConceptoDeInfracciones from 'views/Padrones/Infracciones/Catalogos/ClaseDeConceptoDenfracciones';
import configuracionInfracciones from 'views/Padrones/Infracciones/Catalogos/ConfiguracionDeInfracciones';
import EstadoDeInfracciones from 'views/Padrones/Infracciones/Catalogos/EstadoDeInfracciones';
import ExamenMedico from 'views/Padrones/Infracciones/Catalogos/ExamenMedico';
import Grua from 'views/Padrones/Infracciones/Catalogos/Gruas';
import permisosDeTipoDePlaca from 'views/Padrones/Infracciones/Catalogos/PermisosDeTipoDePlaca';
import sectoresDeInfracciones from 'views/Padrones/Infracciones/Catalogos/SectorDeInfraccion';
import TiposDeDocumentoDeGarantia from 'views/Padrones/Infracciones/Catalogos/TipoDeDocumentosDeGarantia';
import TiposDeInfractores from 'views/Padrones/Infracciones/Catalogos/TipoDeInfractores';
import TipoDeConceptosDeInfraccion from 'views/Padrones/Infracciones/Catalogos/TiposDeConceptosDeInfracciones';
import UnidadPoliciaca from 'views/Padrones/Infracciones/Catalogos/UnidadesPoliciacas';
import Yardas from 'views/Padrones/Infracciones/Catalogos/Yardas';
import Agente from 'views/Padrones/Infracciones/Agentes';
import TipoDeCategoriaDeComercioInformal from 'views/Padrones/ComercioInformal/TipoDeCategoriaDeComercioInformal';
import ClasesDeMultas from 'views/Padrones/Multas/ClasesDeMultas';
import TiposDeObras from 'views/Padrones/Multas/TipoDeObra';
import TiposDeInspectores from 'views/Padrones/Multas/TiposDeInspectores';
import sectorDeMultas from 'views/Padrones/Multas/SectorDeMulta';
import Multas from 'views/Padrones/Multas/Multas';
import DetalleDeUsuarios from 'views/Padrones/Multas/DetalleDeUsuarios';
import EstadosDeMultas from 'views/Padrones/Multas/EstadosDeMultas';
import ConceptosDeMultas from 'views/Padrones/Multas/ConceptosDeMultas';
import MotivoDeMultas from 'views/Padrones/Multas/MotivoDeMultas';
import GirosDeAlcoholes from 'views/Padrones/GirosDeAlcoholes';
import ConstanciasDeInscripcion from 'views/Padrones/ConstanciasDeInscripcion';
import TiposDeDeVehiculos from 'views/Padrones/CatalogosVehiculares/TiposDeVehiculos';
import * as VehiculosSinConfigPadron from 'views/Padrones/VehiculosSinConfigPadron';
import * as ReportePadrones from 'views/Recaudacion/ReportesDePadrones';
import * as ExpedienteDeModulos from 'views/Padrones/Modulos/ExpedienteDeModulos';
import * as Infracciones from 'views/Padrones/Infracciones/Catalogos/CatalogoDeInfracciones';
import Panteones, { catalosgModels as catalogsPanteones } from 'views/Padrones/Panteones';
import PlazaDeMercado from 'views/Padrones/Mercados/PlazaDeMercado';
import ZonaDeMercado from 'views/Padrones/Mercados/ZonasDeMercado';

const ENV_NAME = process.env.REACT_APP_ENV_NAME;
const OAXACA = ENV_NAME === 'oaxaca';
const NAVOJOA = ENV_NAME === 'navojoa';
const PROD = process.env.REACT_APP_ENV === 'PRODUCTION';

export default {
  title: 'Padrones',
  icon: () => <TrademarkOutlined />,
  children: [
    ENV_NAME === 'nayarit' && {
      title: 'Reportes de Padrones',
      component: ReportePadrones.default,
      permissionConfig: ReportePadrones.permissionConfig,
    },
    {
      title: 'Vehícular',
      children: [
        ENV_NAME === 'repuve' ? {
          title: 'Vehículo',
          component: Vehiculos.default,
          permissionConfig: Vehiculos.permissionConfig,
        } : {
          title: 'Vehículo',
          component: VehiculosSinConfigPadron.default,
          permissionConfig: VehiculosSinConfigPadron.permissionConfig,
        },
        ENV_NAME === 'repuve' && {
          title: 'Constancias de Inscripcíon',
          component: ConstanciasDeInscripcion,
          permissionModel: 'constanciadeincripcion',
        },
        {
          title: 'Catálogos',
          children: [
            {
              title: 'Marcas de Vehículos',
              component: Marcas,
              permissionModel: 'marcadelvehiculo',
            },
            ENV_NAME !== 'repuve' && {
              title: 'Marcas de Motocicletas',
              component: Marcas,
              permissionModel: 'marcademotocicleta',
            },
            ENV_NAME !== 'repuve' && {
              title: 'Marcas de Remolques',
              component: Marcas,
              permissionModel: 'marcaderemolque',
            },
            {
              title: `${ENV_NAME === 'repuve' ? 'Submarcas' : 'Líneas'} de Vehículos`,
              component: Lineas,
              permissionModel: 'lineavehicular',
            },
            ENV_NAME !== 'repuve' && {
              title: 'Cuota Fija Para Vehículos',
              component: CuotaFijaParaVehiculos,
              permissionModel: 'cuotafijaparavehiculo',
            },
            {
              title: 'Versión Vehícular',
              component: CatalogoDeVersiones,
              permissionModel: 'versionvehicular',
            },
            ENV_NAME !== 'repuve' && {
              title: 'Porcentajes Vehículares',
              component: PorcentajesVehiculares,
              permissionModel: 'porcentajevehicular',
            },
            ENV_NAME !== 'repuve' && {
              title: 'Tipos de Aplicación de Tarifas Vehículares',
              component: TipoDeAplicacionDeTarifasVehiculares,
              permissionModel: 'tipodeaplicaciondetarifavehicular',
            },
            ENV_NAME !== 'repuve' && {
              title: 'Tabulador de Valor Vehícular',
              component: TabuladorVehicular,
              permissionModel: 'tabuladordevalorvehicular',
            },
            {
              title: 'Tipos de Vehículos',
              component: TiposDeDeVehiculos,
              permissionModel: 'tipodevehiculo',
            },
          ],
        },
        {
          title: 'Gestión de Placas',
          children: [
            {
              title: 'Asignación de placas',
              component: AsignacionDePlacas,
              permissionModel: 'view_crud_asignacion_placas',
            },
            {
              title: 'Configuración de Asignación de placas',
              component: ConfiguracionesDeAsignacionesDePlacas,
              permissionModel: 'configuraciondeasignaciondeplacas',
              catalogsModels: ['serviciodelvehiculo', 'clasedelvehiculo'],
            },
            {
              title: 'Almacén Vehícular',
              component: AlmacenVehicular,
              permissionModel: 'almacenvehicular',
            },
            {
              title: 'Bitácoras de Recepción de Folios Vehículares',
              component: BitacoraRecepcionFolioVehicular,
              permissionModel: 'bitacoraderecepcionfoliovehicular',
            },
            {
              title: 'Contrato Folio Placas',
              component: ContratoFolioPlaca,
              permissionModel: 'contratodefolioplaca',
            },
            {
              title: 'Detalle de Contratos de Folios de las Placas',
              component: DetalleContratoFolioPlaca,
              permissionModel: 'detallecontratofoliosplacas',
            },
            {
              title: 'Estado de Folio de Placas',
              component: EstadoFolioPlaca,
              permissionModel: 'estadodefolioplacaytarjeta',
            },
            {
              title: 'Archivos De Direccion',
              component: ArchivoDeDireccionVerificada,
              permissionModel: 'archivodedireccionverificada',
            },
            {
              title: 'Inventario de Placas y Tarjetas de Circulacion',
              component: InventarioPlacaTarjetaCirculacion,
              permissionModel: 'inventariodeplacasytarjetasdecirculacion',
            },
            {
              title: 'Tipo De Folio Vehícular',
              component: TipoFolioVehicular,
              permissionModel: 'tipofoliovehicular',
            },
            {
              title: 'Placas',
              component: PlacasVehiculares,
              permissionModel: 'placavehicular',
            },
          ],
        },
      ],
    },
    ENV_NAME !== 'repuve' && {
      title: 'Catálogo de Padrones',
      component: Padrones,
      permissionModel: 'padron',
    },
    ENV_NAME !== 'repuve' && {
      title: 'Ciudadano',
      component: Ciudadano,
      permissionModel: 'ciudadano',
      catalogsModels: ['genero', 'estadocivil'],
    },
    {
      title: 'Contribuyente',
      component: Contribuyente.default,
      permissionConfig: Contribuyente.permissionConfig,
    },
    ENV_NAME !== 'repuve' && {
      title: (OAXACA || NAVOJOA) ? 'Comercios' : 'Empresas',
      component: (OAXACA || NAVOJOA) ? Comercios.default : Empresas.default,
      // eslint-disable-next-line max-len
      permissionConfig: (OAXACA || NAVOJOA) ? Comercios.permissionConfig : Empresas.permissionConfig,
    },
    // !TLAJO && {
    //   title: 'Predio',
    //   component: ENV_NAME === 'iprovinay' ? Predio : PredioSinConfigPadron,
    //   permissionModel: 'predio',
    // },
    /* ENV_NAME !== 'navojoa' && */{
      title: 'Panteones',
      component: Panteones,
      permissionModel: 'lotedepanteon',
      catalogsModels: catalogsPanteones,
    },

    ENV_NAME === 'nayarit' && {
      title: 'Hospedaje',
      component: PadronMultiple,
      permissionModel: 'hospedaje',
    },
    ENV_NAME === 'nayarit' && {
      title: 'Cedular Por Arrendamiento',
      component: PadronMultiple,
      permissionModel: 'arrendamiento',
      catalogsModels: ['unidadderecaudacion', 'empresa'],
    },
    ENV_NAME === 'nayarit' && {
      title: 'Nómina',
      component: PadronMultiple,
      permissionModel: 'nomina',
      catalogsModels: ['unidadderecaudacion', 'empresa'],
    },
    ENV_NAME === 'nayarit' && {
      title: 'Cedular por Servicios Profesionales',
      component: PadronMultiple,
      permissionModel: 'cedular',
      catalogsModels: ['unidadderecaudacion', 'empresa'],
    },
    ENV_NAME === 'nayarit' && {
      title: 'Alcohol',
      children: [
        {
          title: 'Alcohol',
          component: PadronMultiple,
          permissionModel: 'alcohol',
          catalogsModels: ['unidadderecaudacion', 'empresa'],
        },
        {
          title: 'Tipos de Alcoholes',
          component: TiposDeAlcoholes,
          permissionModel: 'tipodealcohol',
        },
        {
          title: 'Giros de Alcoholes',
          component: GirosDeAlcoholes,
          permissionModel: 'girodealcohol',
        },
      ],

    },

    ENV_NAME === 'nayarit' && {
      title: 'Juegos de Azar',
      component: PadronMultiple,
      permissionModel: 'juegodeazar',
    },
    ENV_NAME === 'nayarit' && {
      title: 'Notario',
      component: PadronMultiple,
      permissionModel: 'notario',
    },
    ENV_NAME === 'nayarit' && {
      title: 'Casa de Empeño',
      component: PadronMultiple,
      permissionModel: 'casadeempenio',
    },
    ENV_NAME === 'nayarit' && {
      title: 'Agencia',
      component: PadronMultiple,
      permissionModel: 'agencia',
      catalogsModels: ['unidadderecaudacion', 'empresa'],
    },
    !PROD && {
      title: 'Modulos de Mercados',
      component: ExpedienteDeModulos.default,
      permissionConfig: ExpedienteDeModulos.permissionConfig,
    },
    ENV_NAME === 'nayarit' && {
      title: 'Motocicletas',
      component: Motocicletas,
      permissionModel: 'motocicleta',
    },
    ENV_NAME === 'nayarit' && {
      title: 'Remolques',
      component: Remolques,
      permissionModel: 'vehiculo',
    },
    ENV_NAME === 'nayarit' && {
      title: 'Retenedor de Nómina',
      component: PadronMultiple,
      permissionModel: 'retenedordenomina',
    },
    ENV_NAME === 'nayarit' && {
      title: 'Retenedor de Cedular',
      component: PadronMultiple,
      permissionModel: 'retenedorcedular',
    },
    ENV_NAME === 'nayarit' && {
      title: 'Vendedor de Alcoholes',
      component: PadronMultiple,
      permissionModel: 'ventadealcohol',
    },
    ENV_NAME === 'nayarit' && {
      title: 'Estacionamiento',
      component: PadronMultiple,
      permissionModel: 'estacionamiento',
    },
    {
      title: 'Configuración de Padrones',
      component: ConfiguracionDePadrones,
      permissionModel: 'configuraciondepadron',
      catalogsModels: [
        'documentodetramite',
        'horario',
        'anuncio',
        'sucursaldeempresa',
      ],
    },
    ENV_NAME !== 'repuve' && {
      title: 'Bitácora de Padrónes',
      component: Bitacora,
      permissionModel: 'bitacora',
    },
    ENV_NAME === 'juarez' && {
      title: 'Zonas Exclusivas',
      children: [
        {
          title: 'Zona exclusiva',
          component: ZonaExclusiva,
          permissionModel: 'zonaexclusiva',
        },
        {
          title: 'Tipos de zonas exclusivas',
          component: TipoZonaExclusiva,
          permissionModel: 'tipodezonaexclusiva',
        },
      ],
    },
    {
      title: 'Mercados',
      children: [
        {
          title: 'Catálogo de Mercados',
          component: Mercado,
          permissionModel: 'mercado',
        },
        {
          title: 'Expediente de mercado',
          component: ExpedienteDeMercado,
          permissionModel: 'expedientedemercado',
        },
        {
          title: 'Tipo de Mercados',
          component: TiposDeMercados,
          permissionModel: 'tipodemercado',
        },
        {
          title: 'Zonas de Mercado',
          component: ZonaDeMercado,
          permissionModel: 'zonademercado',
        },
        {
          title: 'Plazas de Mercado',
          component: PlazaDeMercado,
          permissionModel: 'plazademercado',
        },
        {
          title: 'Giro de mercado',
          component: GiroDeMercado,
          permissionModel: 'girodemercado',
        },
      ],
    },
    {
      title: 'Comercio en Vía Pública',
      children: [
        {
          title: 'Comercio en Vía Pública',
          component: ExpedienteDeComercioInformal,
          permissionModel: 'expedientedecomercioinformal',
        },
        {
          title: 'Giros de Comercio en Vía Pública',
          component: GiroDeComercioInformal,
          permissionModel: 'girodecomercioinformal',
        },
        ENV_NAME === 'juarez' && {
          title: 'Tipo de Categoría de Comercio',
          component: TipoDeCategoriaDeComercioInformal,
          permissionModel: 'tipodecategoriadecomercioinformal',
        },
      ],
    },
    ENV_NAME === 'juarez' && {
      title: 'Licencias de funcionamiento',
      children: [
        {
          title: 'Expediente',
          component: ExpedienteDeLicencia,
          permissionModel: 'expedientedelicenciafuncionamiento',
        },
        {
          title: 'Categoria de giro',
          component: CategoriasDeGiro,
          permissionModel: 'categoriadegirodelicencia',
        },
        {
          title: 'Giro',
          component: GiroDeLicencia,
          permissionModel: 'girodelicencia',
        },
      ],
    },
    process.env.REACT_APP_ENV_NAME === 'juarez' && {
      title: 'Policias Especiales',
      children: [
        {
          title: 'Contratos de Policias',
          component: ContratosDePolicias,
          permissionModel: 'contratodepolicia',
        },
        {
          title: 'Tipos De Contratos de Policias',
          component: TipoDeContratosDePolicias,
          permissionModel: 'tipodecontratodepolicia',
        },
        {
          title: 'Tipos de Servicios de Policias',
          component: TipoDeServicioDePolicias,
          permissionModel: 'tipodeserviciodepolicia',
        },
      ],
    },
    {
      title: 'Anuncios',
      children: [
        // {
        //   title: 'Clase De Anuncios',
        //   component: ClasesDeAnuncios,
        //   permissionModel: 'clasedeanuncio',
        // },
        {
          title: 'Tipos de Anuncios',
          component: TiposDeAnuncios,
          permissionModel: 'tipodeanuncio',
        },
        // {
        //   title: 'Peritos',
        //   component: Peritos,
        //   permissionModel: 'perito',
        // },
        // {
        //   title: 'Aseguradoras',
        //   component: Aseguradoras,
        //   permissionModel: 'aseguradora',
        // },
        {
          title: 'Expediente de Anuncios',
          component: ExpedienteDeAnuncio,
          permissionModel: 'expedientedeanuncio',
        },
      ],
    },
    {
      title: 'Infracciones',
      children: [
        {
          title: 'Expediente de Infracciones',
          component: Infracciones.default,
          permissionConfig: Infracciones.permissionConfig,
        },
        {
          title: 'Catalógo Clase De Concepto',
          component: ClaseDeConceptoDeInfracciones,
          permissionModel: 'clasedeconceptodeinfraccion',
        },
        {
          title: 'Catálogo Configuracion de Infracciones',
          component: configuracionInfracciones,
          permissionModel: 'configuraciondeinfraccion',
        },
        {
          title: 'Catálogo Estado de las Infracciones',
          component: EstadoDeInfracciones,
          permissionModel: 'estadodelainfraccion',
        },
        {
          title: 'Catalógo Exámen Médico',
          component: ExamenMedico,
          permissionModel: 'examenmedico',
        },
        {
          title: 'Catálogo Gruas',
          component: Grua,
          permissionModel: 'grua',
        },
        {
          title: 'Catálogo Permiso de Tipo de Placas',
          component: permisosDeTipoDePlaca,
          permissionModel: 'permisodetipodeplaca',
        },
        {
          title: 'Catálogo Sector de Infracciones',
          component: sectoresDeInfracciones,
          permissionModel: 'sectordeinfraccion',
        },
        {
          title: 'Catálogo Tipo de Documento de Garantía',
          component: TiposDeDocumentoDeGarantia,
          permissionModel: 'tipodedocumentodegarantia',
        },
        {
          title: 'Catálogo Tipo de Infractores',
          component: TiposDeInfractores,
          permissionModel: 'tipodeinfractor',
        },
        {
          title: 'Catálogo Tipo de Concepto de Infracciones',
          component: TipoDeConceptosDeInfraccion,
          permissionModel: 'tipodeconceptodeinfraccion',
        },
        {
          title: 'Catálogo Unidad Policiaca',
          component: UnidadPoliciaca,
          permissionModel: 'unidadpoliciaca',
        },
        {
          title: 'Catágolo Yardas',
          component: Yardas,
          permissionModel: 'yarda',
        },
        {
          title: 'Catálogo Agentes Policiales',
          component: Agente,
          permissionModel: 'agentepolicial',
        },
      ],
    },
    process.env.REACT_APP_ENV_NAME === 'juarez' && {
      title: 'Multas',
      children: [
        {
          title: 'Expediente de Multas',
          component: Multas,
          permissionModel: 'multa',
        },
        {
          title: 'Clase De Multas',
          component: ClasesDeMultas,
          permissionModel: 'clasedemulta',
        },
        {
          title: 'Conceptos De Multas',
          component: ConceptosDeMultas,
          permissionModel: 'conceptodemulta',
        },
        {
          title: 'Detalle de Usuarios Inspectores',
          component: DetalleDeUsuarios,
          permissionModel: 'detalledeusuario',
        },
        {
          title: 'Estados de Multas',
          component: EstadosDeMultas,
          permissionModel: 'estadodemulta',
        },
        {
          title: 'Motivos de Multas',
          component: MotivoDeMultas,
          permissionModel: 'motivodemulta',
        },
        {
          title: 'Sector de Multa',
          component: sectorDeMultas,
          permissionModel: 'sectordemulta',
        },
        {
          title: 'Tipo de Inspectores',
          component: TiposDeInspectores,
          permissionModel: 'tipodeinspector',
        },
        {
          title: 'Tipo de Obra',
          component: TiposDeObras,
          permissionModel: 'tipodeobra',
        },
      ],
    },
  ],
};
